module.exports = __webpack_public_path__ + "media/components/Giftaid/static/giftaid-107e14c217a15bade17b57b902c9b088.svg";